module.exports = __webpack_public_path__ + "static/media/profile1.9778e1d7.jpg";